import React from "react"
import styled from "styled-components"
import colors from "../styles/colors"
import text from "../styles/text"
import media from "styles/media"
import ContentWidth from "./ContentWidth"

const Contents = ({ content, index }) => {
  return (
    <TableContainer>
      <Headline>{content.headline}</Headline>
      <BodyCopy dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
      <A href={content.link} rel="noopener noreferrer">
        Read More →
      </A>
    </TableContainer>
  )
}

const TableOfContents = ({ content }) => {
  return (
    <ContentWidth>
      <Wrapper>
        <TableContentHeader>TABLE OF CONTENTS</TableContentHeader>
        <MapContainer>
          {content.columns.map((contents, index) => (
            <Contents key={index} index={index} content={contents} />
          ))}
        </MapContainer>
      </Wrapper>
      <Hr />
    </ContentWidth>
  )
}

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  align-content: start;
  align-items: flex-start;
  width: 100%;
  flex-basis: 17%;
  padding-bottom: 2.222vw;
  gap: 1.111vw;

  ${media.fullWidth} {
    padding-bottom: 32px;
    gap: 16px;
  }

  ${media.tablet} {
    padding-bottom: 3.125vw;
    gap: 1.563vw;
  }

  ${media.mobile} {
    padding-bottom: 7.477vw;
    gap: 3.738vw;
  }
`
const Headline = styled.h5`
  ${text.h5};
  color: ${colors.primaryPurple};
  font-weight: bold;

  ${media.mobile} {
    ${text.h4};
  }
`
const BodyCopy = styled.div`
  ${text.bodyMd};
`

const A = styled.a`
  ${text.bodyMd};
`

const TableContentHeader = styled.h6`
  ${text.mdBold};
  display: flex;
  align-self: start;
  color: ${colors.gray800};
  text-align: left;
  margin-bottom: unset;
  font-size: 0.972vw;

  ${media.fullWidth} {
    font-size: 14px;
  }

  ${media.tablet} {
    font-size: 1.367vw;
  }

  ${media.mobile} {
    font-size: 3.271vw;
  }
`
const MapContainer = styled.div`
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  gap: 0vw 6.944vw;
  margin: 1.111vw 0vw 4.444vw 0vw;

  ${media.fullWidth} {
    gap: 0px 100px;
    margin: 16px 0px 64px 0px;
  }

  ${media.tablet} {
    gap: 0vw 9.766vw;
    margin: 1.563vw 0vw 6.25vw 0vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 0vw 23.364vw;
    margin: 3.738vw 0vw 14.953vw 0vw;
  }
`
const Hr = styled.hr`
  width: 100%;

  ${media.fullWidth} {
  }

  ${media.tablet} {
    width: 90%;
  }

  ${media.mobile} {
    width: 90%;
  }
`

const Wrapper = styled.div`
  padding: 0 10.278vw;

  ${media.fullWidth} {
    padding: 0 148px;
  }

  ${media.tablet} {
    padding: 0 4vw;
  }

  ${media.mobile} {
  }
`
export default TableOfContents
